/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";
import "../css/lineclamp2css.css";
import Pagination from "@mui/material/Pagination";
import ScrollToTopButton from "./ScrollToTopButton";
import { useNavigate } from "react-router-dom";
import "css-file-icons";
import { useTranslation } from "react-i18next";
import { CampaignService } from "../services/campaignService";
import { FileService } from "../services/fileService";
import Swal from "sweetalert2";
import {
  Box,
  Grid,
  IconButton,
  Link,
  useMediaQuery,
  Stack,
  Tooltip,
} from "@mui/material";
import SweetAlertService from "../services/SweetAlertService";
import { Modal, Icon } from "./ui";
import functionConstants from "../utils/functionConstants";

function CampaignList() {
  const { t, i18n } = useTranslation();
  const isMobileScreen = useMediaQuery("(max-width:1250px)");
  const [showModal, setShowModal] = useState(false);
  const [editIsOpen, setEditIsOpen] = useState(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [uploadedFileName, setUploadedFileName] = useState("");
  const inputRefCamName = useRef(null);
  const inputRefCamCode = useRef(null);
  const [selectedValue, setSelectedValue] = useState();
  const [Page, setPage] = useState();
  const [Orderby, setOrderby] = useState("updatedDate");
  const [OrderSequence, setOrderSequence] = useState("desc");
  const [campaigns, setCampaigns] = useState([]);
  const [CampaignCode, setCampaignCode] = useState();
  const [CampaignName, setCampaignName] = useState();
  const [preResult, setPreResult] = useState();
  const [nextResult, setNextResult] = useState();
  const [pagination, setPagination] = useState({});
  const [postData, setPostData] = useState({
    pageableParameter: {
      pageNumber: 0,
      pageSize: 10,
      orderBy: Orderby,
      orderSequence: OrderSequence,
    },
    campaignListParameter: {
      campaignCode: CampaignCode ?? "",
      campaignName: CampaignName ?? "",
    },
  });

  const savedLanguage = useMemo(() => i18n.language, [i18n.language]);
  const functionId = localStorage.getItem("functionId");
  const functionList = String(functionId).split(",");

  const createRole = useMemo(() => {
    return (
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_BDELIGHT_CREATE)
      ) ||
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_CICONV_CREATE)
      ) ||
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_KDOLLAR_CREATE)
      )
    );
  }, [functionList]);

  const editRole = useMemo(() => {
    return (
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_BDELIGHT_EDIT)
      ) ||
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_CICONV_EDIT)
      ) ||
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_KDOLLAR_EDIT)
      )
    );
  }, [functionList]);

  const deleteRole = useMemo(() => {
    return (
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_BDELIGHT_DELETE)
      ) ||
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_CICONV_DELETE)
      ) ||
      functionList.includes(
        String(functionConstants.CAMPAIGN_HEADER_KDOLLAR_DELETE)
      )
    );
  }, [functionList]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setPostData({
      pageableParameter: {
        pageNumber: 0,
        pageSize: event.target.value,
        orderBy: Orderby,
        orderSequence: OrderSequence,
      },
      campaignListParameter: {
        campaignCode: CampaignCode,
        campaignName: CampaignName,
      },
    });
  };

  const handlePageChange = (event) => {
    setPage(event);
    setPostData({
      pageableParameter: {
        pageNumber: event - 1,
        pageSize: pagination.pageSize,
        orderBy: Orderby,
        orderSequence: OrderSequence,
      },
      campaignListParameter: {
        campaignCode: CampaignCode,
        campaignName: CampaignName,
      },
    });
  };

  const handleCampaignChange = () => {
    setCampaignCode(inputRefCamCode.current.value.trim());
    setCampaignName(inputRefCamName.current.value.trim());
    setPostData({
      pageableParameter: {
        pageNumber: 0,
        pageSize: pagination.pageSize,
        orderBy: Orderby,
        orderSequence: OrderSequence,
      },
      campaignListParameter: {
        campaignCode: inputRefCamCode.current.value.trim(),
        campaignName: inputRefCamName.current.value.trim(),
      },
    });
  };

  const handleResetChange = () => {
    inputRefCamCode.current.value = "";
    inputRefCamName.current.value = "";
    setCampaignCode("");
    setCampaignName("");
    setPage(1);
    setPostData({
      pageableParameter: {
        pageNumber: 0,
        pageSize: pagination.pageSize,
        orderBy: "updatedDate",
        orderSequence: "desc",
      },
      campaignListParameter: {
        campaignCode: "",
        campaignName: "",
      },
    });
  };

  useEffect(() => {
    var campaignService = new CampaignService();
    campaignService
      .retrieveCampaignHeaders(postData)
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        // if (props.userInformation.role === "pdd-admin" || props.userInformation.role === "pdd-user") {
        //   filteredCampaigns = data.campaignList.filter(campaign => campaign.template === "PDD - CI Conversion Campaign");
        // } else if (props.userInformation.role === "cee-admin" || props.userInformation.role === "cee-user") {
        //   filteredCampaigns = data.campaignList.filter(campaign => campaign.template !== "PDD - CI Conversion Campaign");
        // }
        // setCampaigns(filteredCampaigns);
        if (data.campaignList !== undefined) {
          let filteredCampaigns = data.campaignList;
          setCampaigns(filteredCampaigns);
        }

        if (data.pagination !== undefined) {
          setPagination(data.pagination);

          const pageNumber = parseInt(data.pagination.pageNumber);
          const pageSize = parseInt(data.pagination.pageSize);
          const totalPages = parseInt(data.pagination.totalPages);
          const totalNumberOfRecords = parseInt(
            data.pagination.totalNumberOfRecords
          );
          if (pageNumber === 0) {
            setPreResult(1);
            setNextResult(pageSize);
          } else {
            setPreResult(pageNumber * pageSize + 1);
            setNextResult((pageNumber + 1) * pageSize);
          }

          if (data.pagination.hasNext === "false" && pageNumber !== 0) {
            setPreResult((totalPages - 1) * pageSize + 1);
            setNextResult(totalNumberOfRecords);
          }
        } else {
          let temp = [];
          temp.pageSize = 0;
          temp.totalPages = 0;
          temp.totalNumberOfRecords = 0;
          setPagination(temp);
        }
      })
      .catch((error) => console.error(error));
  }, [postData, selectedValue, Page]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [Page]);

  const handleOrder = (event) => {
    handleOrderBy(event);
    handlePostData(event);
  };

  const handleOrderBy = (event) => {
    setOrderby(event);
  };

  const handlePostData = (event) => {
    if (OrderSequence === "desc") {
      setOrderSequence("asc");
      setPostData({
        pageableParameter: {
          pageNumber: pagination.pageNumber,
          pageSize: pagination.pageSize,
          orderBy: event,
          orderSequence: "asc",
        },
        campaignListParameter: {
          campaignCode: CampaignCode,
          campaignName: CampaignName,
        },
      });
    } else {
      setOrderSequence("desc");
      setPostData({
        pageableParameter: {
          pageNumber: pagination.pageNumber,
          pageSize: pagination.pageSize,
          orderBy: event,
          orderSequence: "desc",
        },
        campaignListParameter: {
          campaignCode: CampaignCode,
          campaignName: CampaignName,
        },
      });
    }
  };

  const navigate = useNavigate();

  const EditCampaign = (event) => {
    navigate("/EditCampaign", { state: { event } });
  };

  const ViewDetail = (
    campaignHeaderId,
    campaignNameEng,
    campaignNameHk,
    campaignNameCn,
    campaignTemplate,
    latestupdateDate
  ) => {
    navigate("/CampaignDetail", {
      state: {
        campaignHeaderId,
        campaignNameEng,
        campaignNameHk,
        campaignNameCn,
        campaignTemplate,
        latestupdateDate,
      },
    });
  };

  const openEdit = (thumbnailDocID) => {
    handlePreview(thumbnailDocID);
    setEditIsOpen(true);
  };

  const closeEdit = () => {
    setUploadedFileName("");
    setUploadedFile("");
    setEditIsOpen(false);
    setShowModal(false);
  };

  const handlePreview = async (thumbnailDocID) => {
    const loadingSwal = SweetAlertService.showLoading(t("common.loading"));
    var fileService = new FileService();
    await fileService
      .download(thumbnailDocID)
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        SweetAlertService.close(loadingSwal);
        if (data.documentName) {
          setUploadedFileName(data.documentName);
          setUploadedFile(data.documentBase64String);
        }
      })
      .catch((error) => console.error(error));
  };

  const preview = useCallback(() => {
    const fileExtension = uploadedFileName.split(".").pop().toLowerCase();
    if (
      fileExtension === "png" ||
      fileExtension === "jpg" ||
      fileExtension === "jpeg" ||
      fileExtension === "gif"
    ) {
      // Image preview
      return (
        <img
          className="text-content"
          src={`data:image/${fileExtension};base64,${uploadedFile}`}
          alt="file"
        />
      );
    }
  }, [uploadedFileName, uploadedFile]);

  const download = () => {
    const fileExtension = uploadedFileName.split(".").pop().toLowerCase();
    let fileType = "";
    switch (fileExtension) {
      case "csv":
        fileType = "text/csv";
        break;
      case "doc":
        fileType = "application/msword";
        break;
      case "docx":
        fileType =
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        break;
      case "ppt":
        fileType = "application/vnd.ms-powerpoint";
        break;
      case "pptx":
        fileType =
          "application/vnd.openxmlformats-officedocument.presentationml.presentation";
        break;
      case "xls":
        fileType = "application/vnd.ms-excel";
        break;
      case "xlsx":
        fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        break;
      case "pdf":
        fileType = "application/pdf";
        break;
      case "png":
        fileType = "image/png";
        break;
      case "jpeg":
      case "jpg":
        fileType = "image/jpeg";
        break;
      case "gif":
        fileType = "image/gif";
        break;
      default:
        fileType = "application/octet-stream";
        break;
    }
    if (
      fileExtension === "png" ||
      fileExtension === "jpg" ||
      fileExtension === "jpeg" ||
      fileExtension === "gif"
    ) {
      // Image preview
      return (
        <div>
          <div className="text-center">
            <p>{uploadedFileName}</p>
          </div>
          <div className="w-72 flex mt-5 justify-between">
            <div className="">
              <button className=" text-white bg-ft-light rounded px-3 py-2">
                <a
                  className="text-white no-underline"
                  href={`data:${fileType};base64,${uploadedFile}`}
                  download={uploadedFileName}>
                  {t("common.download")}
                </a>
              </button>
            </div>
            <div className="">
              <button
                className="no-underline bg-ft-light text-white px-3 py-2 rounded"
                onClick={closeEdit}>
                {t("common.close")}
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      const reArrange = "fi fi-size-xl fi-" + fileExtension;
      return (
        <div>
          <div className="mt-3">
            <div className={reArrange}>
              <div className="fi-content">{fileExtension}</div>
            </div>
            <div className="text-center">
              <p>{uploadedFileName}</p>
            </div>
          </div>
          <div className="w-84 flex mt-5 justify-center">
            <div className="mr-10">
              <button className=" text-white bg-ft-light rounded px-3 py-2">
                <a
                  className="no-underline text-white"
                  href={`data:application/octet-stream;base64,${uploadedFile}`}
                  download={uploadedFileName}>
                  {t("common.download")}
                </a>
              </button>
            </div>
            <div className="">
              <button
                className="no-underline bg-ft-light text-white px-3 py-2 rounded"
                onClick={closeEdit}>
                {t("common.close")}
              </button>
            </div>
          </div>
        </div>
      );
    }
  };

  const openMobile = (docId) => {
    handlePreview(docId);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    // Show a confirmation dialog before deleting the URL
    const result = await Swal.fire({
      icon: "warning",
      title: t("common.deleteConfirmText"),
      showCancelButton: true,
      confirmButtonColor: "#dc3545", // set confirm button color to red
      confirmButtonText: t("common.delete"),
      cancelButtonText: t("common.cancel"),
    });

    // Check if the user clicked the delete button
    if (result.isConfirmed) {
      var campaignService = new CampaignService();
      campaignService.deleteCamapignHeader(id).then((value) => {
        if (value.status === 200) {
          window.location.reload();
        } else {
          // Handle error
          console.error("Error deleting item");
        }
      });
    }
  };

  const ListItem = useMemo(() => {
    if (!campaigns) return;

    return campaigns.map((list) => {
      const isExpired =
        new Date() >= new Date(list.campaignEndDate) ? (
          <>{t("common.expired")}</>
        ) : null;

      const isUnposted =
        new Date() <= new Date(list.campaignStartDate) ? (
          <>{t("common.unposted")}</>
        ) : null;

      return {
        "campaignPage.campaignName": (
          <Link
            onClick={() =>
              ViewDetail(
                list.campaignHeaderId,
                list.campaignNameEng,
                list.campaignNameHk,
                list.campaignNameCn,
                list.template,
                list.updatedDate.toISOString().slice(0, 10)
              )
            }
            href="/CampaignDetail"
            underline="none"
            sx={{ "&:hover": { color: "primary.dark" } }}>
            {isExpired}
            {isUnposted}
            {savedLanguage === "en"
              ? list.campaignNameEng
              : savedLanguage === "cn"
              ? list.campaignNameCn
              : list.campaignNameHk}
          </Link>
        ),
        "campaignPage.campaignCode": list.campaignCode,
        "common.startDate": list.campaignStartDate,
        "common.endDate": list.campaignEndDate,
        "campaignPage.latestUpdated": list.updatedDate,
        "common.ifaCa": list.ifaCaIndicator,
        "campaignPage.remarks": list.remark,
        ...(list.fileId !== "-1" && list.fileId !== "0"
          ? {
              "campaignPage.preview": (
                <IconButton
                  onClick={() => openMobile(list.fileId)}
                  sx={{ p: 0, justifyContent: "flex-start" }}>
                  <Icon src="preview" color="primary" />
                </IconButton>
              ),
            }
          : null),
        ...(editRole && list.template !== "bdelight"
          ? {
              "common.edit": (
                <IconButton
                  onClick={() => EditCampaign(list)}
                  sx={{ p: 0, justifyContent: "flex-start" }}>
                  <Icon src="edit" color="primary" />
                </IconButton>
              ),
            }
          : null),
        ...(deleteRole && list.template !== "bdelight"
          ? {
              "common.delete": (
                <IconButton
                  onClick={() => handleDelete(list.campaignHeaderId)}
                  sx={{ p: 0, justifyContent: "flex-start" }}>
                  <Icon src="delete" color="primary" />
                </IconButton>
              ),
            }
          : null),
      };
    });
  }, [campaigns]);

  return (
    <>
      {isMobileScreen ? (
        <div className="w-full ">
          <div className="flex">
            <h1 className="text-header font-bold text-ft-light w-3/4">
              {t("campaignPage.campaign")}
            </h1>

            {createRole ? (
              <a
                className="no-underline w-1/4 text-tableHeader bg-ft-light text-center text-white py-2 px-3 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft"
                href="/CreateCampaign">
                {t("common.create")}
              </a>
            ) : (
              <></>
            )}
          </div>
          <div className="mt-4 text-tableHeader">
            <span>{t("campaignPage.campaignName")}</span>
            <span className="input-search">
              <input
                data-input=""
                className="form-control py-2 text-tableHeader"
                type="search"
                placeholder={t("campaignPage.campaignName")}
                maxLength="500"
                id="Input_SearchCampaignName"
                ref={inputRefCamName}
                style={{ userSelect: "auto" }}
              />
            </span>
          </div>
          <div className="mt-3 text-tableHeader">
            <span>{t("campaignPage.campaignCode")}</span>
            <span className="input-search">
              <input
                data-input=""
                className="form-control py-2 text-tableHeader"
                type="search"
                placeholder={t("campaignPage.campaignCode")}
                maxLength="500"
                ref={inputRefCamCode}
                id="Input_SearchCampaignCode"
                style={{ userSelect: "auto" }}
              />
            </span>
          </div>
          <div className="flex">
            <div className="flex mt-3 text-tableHeader w-1/2 mr-5">
              <a
                onClick={() => handleCampaignChange()}
                className="no-underline text-center w-full bg-ft-light text-white py-2 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft">
                {t("common.search")}
              </a>
            </div>
            <div className="flex mt-3 text-tableHeader w-1/2 ">
              <a
                onClick={() => handleResetChange()}
                className="no-underline text-center w-full bg-white text-ft-light ring-ft-light ring-1 py-2 rounded hover:bg-ft hover:text-white active:bg-ft-light active:ring-1 active:ring-ft">
                {t("common.reset")}
              </a>
            </div>
          </div>
          <div className="mt-4 text-tableHeader">
            <p>
              {t("common.showPerPage1")}
              <select
                id="countries"
                aria-label="Select page size"
                className="mx-2 w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                value={selectedValue}
                onChange={handleChange}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              {t("common.showPerPage2")}
            </p>
          </div>
          {showModal ? (
            <>
              <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-5/6 my-6 mx-auto max-w-3xl">
                  {/*content*/}
                  <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                    <button
                      className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => setShowModal(false)}>
                      <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                        ×
                      </span>
                    </button>

                    {/*body*/}
                    <div className="relative p-6 flex-auto">
                      <h1 className="text-center mb-5">
                        {t("campaignPage.preview")}
                      </h1>
                      {preview()}
                      {download()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </>
          ) : null}

          <Box sx={{ flexGrow: 1 }}>
            {ListItem.map((item, index) => (
              <Grid
                container
                key={index}
                direction="row"
                boxShadow={5}
                borderRadius={2}
                mb={2}
                overflow="hidden">
                {Object.entries(item).map(([key, value]) => (
                  <React.Fragment key={key}>
                    <Grid
                      item
                      xs={3}
                      sx={{
                        p: 1,
                        bgcolor: "primary.main",
                        color: "white",
                        fontWeight: 700,
                      }}>
                      {t(key)}
                    </Grid>
                    <Grid item xs={9} sx={{ p: 1 }}>
                      {value}
                    </Grid>
                  </React.Fragment>
                ))}
              </Grid>
            ))}
          </Box>

          <div className="flex flex-col items-center">
            <div>
              {pagination.totalNumberOfRecords === 0 ? (
                <p className="text-sm text-gray-700">{t("common.noRecord")}</p>
              ) : (
                <p className="text-sm text-gray-700">
                  {t("common.showPage1")}
                  <span className="font-medium"> {preResult}</span>{" "}
                  {t("common.showPage2")}{" "}
                  <span className="font-medium">{nextResult}</span>{" "}
                  {t("common.showPage3")}{" "}
                  <span className="font-medium">
                    {pagination.totalNumberOfRecords}
                  </span>{" "}
                  {t("common.showPage4")}
                </p>
              )}
            </div>
            {pagination && pagination.totalNumberOfRecords > 0 && (
              <Stack spacing={2}>
                <Pagination
                  page={parseInt(pagination.pageNumber) + 1}
                  shape={"circular"}
                  count={
                    pagination.totalNumberOfRecords &&
                    pagination.pageSize &&
                    !isNaN(pagination.totalNumberOfRecords) &&
                    !isNaN(pagination.pageSize)
                      ? Math.ceil(
                          pagination.totalNumberOfRecords / pagination.pageSize
                        )
                      : 0
                  }
                  onChange={(e, value) => handlePageChange(value)}
                />
              </Stack>
            )}
          </div>
          <ScrollToTopButton />
        </div>
      ) : (
        <div className="w-deflaut px-2">
          <div className="flex justify-content-between align-items-center my-3">
            <p className="text-header text-ft-light font-bold">
              {t("campaignPage.campaign")}
            </p>

            {createRole ? (
              <div className="">
                <a
                  className="no-underline text-tableHeader bg-ft-light text-white px-3 py-2 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft"
                  href="/CreateCampaign">
                  {t("common.create")}
                </a>
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="w-full flex justify-center mb-4 text-content">
            <div className="w-1/3 mr-5 ">
              <span>{t("campaignPage.campaignName")}</span>
              <span className="input-search">
                <input
                  data-input=""
                  className="form-control text-content"
                  type="search"
                  placeholder={t("campaignPage.campaignName")}
                  maxLength="500"
                  id="Input_SearchCampaignName"
                  ref={inputRefCamName}
                  style={{ userSelect: "auto" }}
                />
              </span>
            </div>
            <div className="w-1/3 mr-5">
              <span>{t("campaignPage.campaignCode")}</span>
              <span className="input-search">
                <input
                  data-input=""
                  className="form-control text-content"
                  type="search"
                  placeholder={t("campaignPage.campaignCode")}
                  maxLength="500"
                  ref={inputRefCamCode}
                  id="Input_SearchCampaignCode"
                  style={{ userSelect: "auto" }}
                />
              </span>
            </div>
            <div className="w-1/3 flex flex-col justify-between text-content">
              <div className="h-1/2"></div>
              <div className="h-1/2 flex">
                <div className="mr-5 text-tableHeader">
                  <a
                    onClick={() => handleCampaignChange()}
                    className="cursor-pointer no-underline text-tableHeader bg-ft-light text-white px-3 py-2 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft">
                    {t("common.search")}
                  </a>
                </div>
                <div className="text-tableHeader">
                  <a
                    onClick={() => handleResetChange()}
                    className="cursor-pointer no-underline text-tableHeader bg-white text-ft-light ring-ft-light ring-1 px-3 py-2 rounded hover:bg-ft hover:text-white active:bg-ft-light active:ring-1 active:ring-ft">
                    {t("common.reset")}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="mr-5 text-content">
            <p>
              {t("common.showPerPage1")}
              <select
                id="countries"
                aria-label="Select page size"
                className="mx-2 w-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-ft-light focus:border-ft-light p-2.5"
                value={selectedValue}
                onChange={handleChange}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              {t("common.showPerPage2")}
            </p>
          </div>
          <Modal open={editIsOpen && !!uploadedFile} onClose={closeEdit}>
            <h1 className="mb-4 text-header text-ft-light">
              {t("campaignPage.preview")}
            </h1>
            {preview()}
            {download()}
          </Modal>
          <div className="overflow-y-hidden">
            <table className="rounded-md border-collapse border border-slate-800 w-table ">
              <thead className="text-tableHeader">
                <tr className="border border-slate-300 ">
                  <th
                    className=" hover:text-ft-light cursor-pointer pl-5 w-tableName "
                    onClick={() => handleOrder("campaignNameEng")}>
                    {t("campaignPage.campaignName")}
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      className="inline-block w-4 h-4 ml-1">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                    </svg>
                  </th>
                  <th
                    className=" hover:text-ft-light cursor-pointer w-tableCode "
                    onClick={() => handleOrder("campaignCode")}>
                    {t("campaignPage.campaignCode")}
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      className="inline-block w-4 h-4 ml-1">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                    </svg>
                  </th>
                  <th
                    className=" hover:text-ft-light cursor-pointer w-tableDate "
                    onClick={() => handleOrder("campaignStartDate")}>
                    {t("common.startDate")}
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      className="inline-block w-4 h-4 ml-1">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                    </svg>
                  </th>
                  <th
                    className=" hover:text-ft-light cursor-pointer w-tableDate"
                    onClick={() => handleOrder("campaignEndDate")}>
                    {t("common.endDate")}
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      className="inline-block w-4 h-4 ml-1">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                    </svg>
                  </th>
                  <th
                    className={
                      savedLanguage === "en"
                        ? "hover:text-ft-light cursor-pointer w-tableUpdateDate"
                        : "hover:text-ft-light cursor-pointer w-tableDate "
                    }
                    onClick={() => handleOrder("updatedDate")}>
                    {t("campaignPage.latestUpdated")}
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      className="inline-block w-4 h-4 ml-1">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                    </svg>
                  </th>

                  <th
                    className=" hover:text-ft-light cursor-pointer w-tableRemark"
                    onClick={() => handleOrder("remark")}>
                    {t("campaignPage.remarks")}
                    <svg
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      className="inline-block w-4 h-4 ml-1">
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"></path>
                    </svg>
                  </th>
                  <th className=" w-tablePreview text-center">
                    {t("campaignPage.preview")}
                  </th>
                  {editRole ? (
                    <>
                      <th className=" w-tableEdit">{t("common.edit")}</th>
                    </>
                  ) : (
                    <></>
                  )}
                  {deleteRole ? (
                    <>
                      <th className="w-tableDelete">{t("common.delete")}</th>
                    </>
                  ) : (
                    <></>
                  )}
                </tr>
              </thead>
              <tbody className="text-left text-content">
                {campaigns.map((campaign) => {
                  const startDate = new Date(campaign.campaignStartDate);
                  const endDate = new Date(campaign.campaignEndDate);
                  const updatedDate = new Date(campaign.updatedDate);
                  const formattedStartDate = startDate
                    .toISOString()
                    .slice(0, 10);
                  const formattedEndDate = endDate.toISOString().slice(0, 10);
                  const formattedUpdatedDate = updatedDate
                    .toISOString()
                    .slice(0, 10);

                  if (campaign.remark === "NULL") {
                    campaign.remark = "";
                  }

                  let checkDelete = "N";
                  let checkEdit = "N";

                  if (editRole && campaign.template !== "bdelight") {
                    checkEdit = "Y";
                  }

                  if (deleteRole && campaign.template !== "bdelight") {
                    checkDelete = "Y";
                  }

                  const isExpired =
                    new Date() >= endDate ? <>{t("common.expired")}</> : null;

                  const isUnposted =
                    new Date() <= startDate ? (
                      <>{t("common.unposted")}</>
                    ) : null;
                  return (
                    <tr
                      className="border border-slate-300 h-16 "
                      key={campaign.campaignHeaderId}>
                      <td className="">
                        <div className="no-underline w-tableName lineclamp2 pl-5">
                          <Tooltip
                            title={
                              savedLanguage === "en"
                                ? campaign.campaignNameEng
                                : savedLanguage === "cn"
                                ? campaign.campaignNameCn
                                : campaign.campaignNameHk
                            }
                            arrow>
                            <a
                              onClick={() =>
                                ViewDetail(
                                  campaign.campaignHeaderId,
                                  campaign.campaignNameEng,
                                  campaign.campaignNameHk,
                                  campaign.campaignNameCn,
                                  campaign.template,
                                  formattedUpdatedDate
                                )
                              }
                              className="no-underline text-ft-light hover:text-ft "
                              href="/CampaignDetail">
                              {isExpired}
                              {isUnposted}
                              {savedLanguage === "en"
                                ? campaign.campaignNameEng
                                : savedLanguage === "cn"
                                ? campaign.campaignNameCn
                                : campaign.campaignNameHk}
                            </a>
                          </Tooltip>
                        </div>
                      </td>

                      <td className="">
                        <div className="w-tableCode line-clamp-1">
                          <Tooltip title={campaign.campaignCode} arrow>
                            {campaign.campaignCode}
                          </Tooltip>
                        </div>
                      </td>
                      <td className="w-tableDate">{formattedStartDate}</td>
                      <td className="w-tableDate">{formattedEndDate}</td>
                      <td
                        className={
                          savedLanguage === "en"
                            ? "w-tableUpdateDate"
                            : "w-tableDate"
                        }>
                        {formattedUpdatedDate}
                      </td>
                      <td className="w-talbeRemark">
                        <div
                          data-tooltip-target="tooltip-default"
                          className="w-32 lineclamp2">
                          <Tooltip title={campaign.remark} arrow>
                            {campaign.remark}
                          </Tooltip>
                        </div>
                      </td>

                      <td className="">
                        <div className="flex w-tablePreview align-middle justify-center ">
                          {campaign.fileId !== "-1" &&
                          campaign.fileId !== "0" ? (
                            <a
                              onClick={() => openEdit(campaign.fileId)}
                              className=" cursor-pointer">
                              <Icon src="preview" color="primary" />
                            </a>
                          ) : (
                            <></>
                          )}
                        </div>
                      </td>
                      {checkEdit === "Y" ? (
                        <>
                          <td className="">
                            <div className="w-tableEdit">
                              <a
                                onClick={() => EditCampaign(campaign)}
                                href="/EditCampaign">
                                <Icon src="edit" color="primary" />
                              </a>
                            </div>
                          </td>
                        </>
                      ) : (
                        <></>
                      )}
                      {checkDelete === "Y" ? (
                        <>
                          <td className="pr-3 h-8 mb-1">
                            <div className="w-talbeDelete">
                              <a
                                className="cursor-pointer"
                                onClick={() =>
                                  handleDelete(campaign.campaignHeaderId)
                                }>
                                <Icon src="delete" color="primary" />
                              </a>
                            </div>
                          </td>
                        </>
                      ) : (
                        <></>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="flex items-center justify-between px-4 py-3 md:px-6">
            <div className="hidden md:flex md:flex-1 md:items-center md:justify-between">
              <div>
                {pagination.totalNumberOfRecords === 0 ? (
                  <p className=" text-gray-700 text-content">
                    {t("common.noRecord")}
                  </p>
                ) : (
                  <p className=" text-gray-700 text-content">
                    {t("common.showPage1")}
                    <span className="font-medium"> {preResult}</span>{" "}
                    {t("common.showPage2")}{" "}
                    <span className="font-medium">{nextResult}</span>{" "}
                    {t("common.showPage3")}{" "}
                    <span className="font-medium">
                      {pagination.totalNumberOfRecords}
                    </span>{" "}
                    {t("common.showPage4")}
                  </p>
                )}
              </div>
              <div>
                {pagination && pagination.totalNumberOfRecords > 0 && (
                  <Stack spacing={2}>
                    <Pagination
                      page={parseInt(pagination.pageNumber) + 1}
                      shape={"circular"}
                      count={
                        pagination.totalNumberOfRecords &&
                        pagination.pageSize &&
                        !isNaN(pagination.totalNumberOfRecords) &&
                        !isNaN(pagination.pageSize)
                          ? Math.ceil(
                              pagination.totalNumberOfRecords /
                                pagination.pageSize
                            )
                          : 0
                      }
                      onChange={(e, value) => handlePageChange(value)}
                    />
                  </Stack>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CampaignList;
